import * as _ from 'underscore';
import { StudioApplication } from '..';
import { ID, Icons } from '../../const';
import { Templates } from '../../compile';
import { View } from 'mappMvc/models/views';
import { BaseForm } from 'mappMvc/models/ui/forms';
import { Notification, Util } from 'mappMvc/models';
import { Label, Password, NotificationElement, Input, Button, QRCode } from 'mappMvc/models/ui/uiElements';
import { ViewOptions } from 'mappMvc/interfaces/options';
import { KoExtensions } from 'mappMvc/extensions/ko';
import { KeyCode, NotificationType } from 'mappMvc/enums';
import { MetadataClient } from 'mappClient/metadataClient';
import { LoginError } from '../interface';
import { Localization } from 'mappMvc/compile';
import { IKeyValue } from 'mappMvc/interfaces';
import { SecurityClient } from 'mappClient/clients';
import { Size } from 'mappMvc/const';



export class SetupTwoFactorAuthentication extends View {
	public password: KnockoutObservable<string>;
	public token: KnockoutObservable<string>;

	private form: BaseForm;
	private studio: StudioApplication;
	private notification: Notification;

	private submitLabel: KnockoutObservable<string>;
	private editableForm: KnockoutObservable<boolean>;

	private userId: string;
	private secret: string;
	private url: KnockoutObservable<string>;

	constructor(options: ViewOptions) {
		super(
			_.defaults(options, <ViewOptions>{
				viewId: ID.SetupTwoFactorAuthentication,
				template: Templates.base_centered,
				label: Localization.Login.EnableTwoFactor,
				icon: Icons.Security
			})
		);
		//hack to prevent studio/login url
		this.parent = null;
		this.studio = <StudioApplication>options.parent;
		this.password = KoExtensions.observable<string>();
		this.token = KoExtensions.observable<string>();

		this.notification = new Notification();
		this.submitLabel = ko.observable<string>(Localization.Save);
		this.editableForm = ko.observable<boolean>(true);

		this.url = ko.observable<string>();

		this.form = new BaseForm({
			initDefaultCommands: false,
			commands: [
				{
					command: () => this.form.submit(),
					label: this.submitLabel,
					css: Icons.Ok,
					template: Templates.forms_action
				}
			]
		});

		this.form.addUIElement(new NotificationElement('notification', null, this.notification, {}));

		this.form.addUIElement(new QRCode('qrcode', Localization.Login.QrCode, this.url, {
			label: {
				size: Size._1_1
			},
			css: 'setup-two-factor-qr-code'
		}));

		this.form.addUIElement(
			new Input('token', Localization.Login.Token, this.token, {
				template: Templates.layouts_uiElements_labelValidationWidget,
				rules: [{ rule: 'required', params: true }],
				css: 'validation-right',
				editable: this.editableForm
			})
		);

		this.form.addUIElement(
			new Password('password', Localization.Login.CurrentPassword, this.password, null, {
				template: Templates.layouts_uiElements_labelValidationWidget,
				rules: [{ rule: 'required', params: true }],
				css: 'validation-right',
				editable: this.editableForm,
				label: {
					size: Size._1_2
				}
			})
		);

		this.form.ClickedSubmit.subscribe((data: IKeyValue<any>) => {
			if (this.editableForm()) {
				this.setupTwoFactorAuthentication(data);
			}
		});

		this.ViewActivated.subscribe(async () => {
			let result = await SecurityClient.requestTwoFactorAuthentication(this.userId);
			this.url(result.url);
			this.secret = result.secret;

			this.notification.hide();
			Util.setValue(null, this.password, this.token);
			this.form.hideValidationMessages();
			Util.bindKey(KeyCode.ENTER, this.form.submit, this.form);
			setTimeout(() => (<HTMLInputElement>document.querySelector('input#password')).focus(), 0);
		});

		this.ViewDeactivated.subscribe(() => {
			Util.unbindKey(KeyCode.ENTER, this.form.submit);
		});
	}

	public setUserId(userId: string) {
		this.userId = userId;
	}

	private async setupTwoFactorAuthentication(formData: IKeyValue<any>) {
		this.editableForm(false);
		this.notification.notify(Localization.Progress.Saving, NotificationType.Hint);
		this.notification.show();

		await SecurityClient.confirmTwoFactorAuthentication(this.userId, {
			currentPassword: this.password(),
			secret: this.secret,
			token: this.token()
		});

		this.studio.forceLogIn();
	}
}
